module.exports = __webpack_public_path__ + "img/area-limit-cancel-btn.750c74a2.png";